import { useMutation } from "@apollo/client";
import { PrefetchSearchResultsDocument } from "__generated__/typedefs";

export const usePreloadPropertySearchMutation = () => {
  const [executeMutation] = useMutation(PrefetchSearchResultsDocument);
  return {
    executeMutation,
  };
};
